import Vue from 'vue'
import moment from 'moment'

const axiosKomship = partnerId => {
  const axios = Vue.prototype.$http_komship
  axios.defaults.params = { partner_id: partnerId }
  return axios
}
const axiosKomshipNoLimit = partnerId => {
  const axios = Vue.prototype.$http_no_limit
  axios.defaults.params = { partner_id: partnerId }
  return axios
}
const axiosKomshipNew = partnerId => {
  const axios = Vue.prototype.$http_new
  axios.defaults.params = { partner_id: partnerId }
  return axios
}
const axiosKompack = () => Vue.prototype.$http_kompack

const kompackDate = new Date('2021-01-01')

const today = new Date()
today.setHours(0, 0, 0, 0)

const last2 = new Date()
last2.setDate(today.getDate() - 1)
last2.setHours(0, 0, 0, 0)

const last3 = new Date()
last3.setDate(today.getDate() - 3)
last3.setHours(0, 0, 0, 0)

const last7 = new Date()
last7.setDate(today.getDate() - 6)
last7.setHours(0, 0, 0, 0)

const last14 = new Date()
last14.setDate(today.getDate() - 13)
last14.setHours(0, 0, 0, 0)

const last30 = new Date()
last30.setDate(today.getDate() - 29)
last30.setHours(0, 0, 0, 0)

const last60 = new Date()
last60.setDate(today.getDate() - 59)
last60.setHours(0, 0, 0, 0)

const last90 = new Date()
last90.setDate(today.getDate() - 89)
last90.setHours(0, 0, 0, 0)

const lastDateFromToday = days => {
  const date = new Date()
  date.setDate(today.getDate() - (days - 1))
  date.setHours(0, 0, 0, 0)
  return date
}

const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
const lastDateOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
const lastDateOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0)

const ranges = {
  'Real Time': [today, today],
  '7 Hari Terakhir': [last7, today],
  '30 Hari Terakhir': [last30, today],
  '1 Bulan Terakhir': [last30, today],
  '2 Bulan Terakhir': [last60, today],
  '3 Bulan Terakhir': [last90, today],
  'Bulan Ini': [firstDateOfMonth, today],
  'Custom Tanggal': [null, null],
}

const penghasilanValue = {
  Kompship: 1,
  'Non Kompship': 0,
}

const paymentMethods = {
  COD: 'COD',
  'Transfer Bank': 'BANK TRANSFER',
}

const formatYmd = date => moment(date).format('YYYY-MM-DD')

const datePickerLocale = {
  format: 'dd/mm/yyyy',
  daysOfWeek: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
  monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
}

const datePickerRanges = {
  'Hari Ini': [today, today],
  Kemarin: [last2, last2],
  '7 Hari Terakhir': [last7, today],
  '30 Hari Terakhir': [last30, today],
  'Bulan Ini': [firstDateOfMonth, today],
  'Bulan Lalu': [lastMonth, lastDateOfLastMonth],
}

const hideAccount = account => {
  if (!account) return ''
  const { length } = account
  return Array(length - 4).join('*') + account.slice(-4)
}

const getDates = (start, end) => {
  const arr = []
  const dt = new Date(start)

  while (dt <= new Date(end)) {
    arr.push(moment(dt).format('YYYY-MM-DD'))
    dt.setDate(dt.getDate() + 1)
  }

  return arr
}

export {
  axiosKomship,
  axiosKomshipNew,
  axiosKompack,
  kompackDate,
  today,
  last7,
  last14,
  last30,
  last60,
  last90,
  lastDateFromToday,
  firstDateOfMonth,
  lastDateOfMonth,
  ranges,
  penghasilanValue,
  formatYmd,
  datePickerLocale,
  datePickerRanges,
  hideAccount,
  paymentMethods,
  getDates,
  last2,
  lastMonth,
  axiosKomshipNoLimit,
  lastDateOfLastMonth,
}
